// src/api/tenant/tenant.js

import { http } from "../base"
import { ssoHttp } from "../base"
import {TOKEN_CONFIG} from "../config"


    /**
     * 获取当前用户的租户信息
     */
    export function getTenantinfo(tenant_id) {
        console.log("getTenantinfo",tenant_id)
      return http.get("/tenant/my-tenant-info/"+tenant_id)
    }

    
export async function postBrief(formData) {
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }      
    try {
        const response = await http.post(
            `/tenant/save_brief`,
        formData,


    )
    return response
    } catch (error) {
        return error
    }
  }
export async function get_my_tenant_deregistration_info(tenant_id) {
    try {
        const response = await http.get(
            `/tenant/my-tenant-deregistration/${tenant_id}`, {
      headers: { 'Content-Type': 'application/json' }
    })
  console.log("/tenant/my-tenant-deregistration",response);
  // 统一处理响应格式
  if (response == null || response.status !== 200) {
    throw new Error(response?.data?.message || '获取租户注销信息失败');
  }
  return response.data;
} catch (error) {
    return error
 }
}

export async function postTenantDeregistrationApply(formData) {
    console.log("postTenantDeregistrationApply 提交数据:");
    
    // 注意：这里假设 formData 已经包含了 tenant_id, data_protect_way, picFile
    // 关键修复：确保 data_protect_way 是以 text/plain 类型添加的
    // 如果你是在外部构建 formData，那么在这里需要重新处理一下 data_protect_way
    
    // 示例：如果你是在这个函数内部构建 formData，应该这样做：
    /*
    const formData = new FormData();
    formData.append('tenant_id', tenantId); // 这是普通字符串，没问题
    // 关键行：将 data_protect_way 包装成 Blob，并指定 type 为 'text/plain'
    const blob = new Blob([String(dataProtectWay)], { type: 'text/plain' });
    formData.append('data_protect_way', blob);
    formData.append('picFile', picFile); // 这是文件，没问题
    */
    
    // 如果你是从外部传入的 formData，并且已经包含了这些字段，
    // 你需要检查 data_protect_way 是如何被 append 进去的。
    // 如果是直接 formData.append('data_protect_way', 1)，它可能会被识别为 application/octet-stream。
    // 你应该改为：
    // const blob = new Blob(['1'], { type: 'text/plain' });
    // formData.append('data_protect_way', blob);
    
    // 下面是你的原始调试代码，可以保留
    for (let pair of formData.entries()) {
        console.log(pair[0] + ': ', pair[1]);
    }  
    
    try {
        const response = await ssoHttp.post(
            `v1/tenant/deregistration_apply`,
            formData,      
            {
                headers: { 
                    'X-Auth-Token': TOKEN_CONFIG.AICS_TOKEN 
                    // 注意：不要手动设置 Content-Type 为 multipart/form-data，
                    // 让浏览器自动设置，它会自动包含 boundary
                }      
            }
        )
        console.log("postTenantDeregistrationApply 响应:", response)
        return response
    } catch (error) {
        console.error("postTenantDeregistrationApply 错误:", error)
        
        if (error.response) {
            console.error("错误响应状态:", error.response.status)
            console.error("错误响应数据:", error.response.data)
        }
        
        throw error
    }
}

export async function postTenantDeregistrationRestoredataApply(formData) {
    console.log("postTenantDeregistrationRestoredataApply 提交数据:", formData, TOKEN_CONFIG.AICS_TOKEN);
    
    // 将FormData转为普通对象
    const data = {};
    for (let [key, value] of formData.entries()) {
        data[key] = value;
    }
    
    const response = await ssoHttp.post(
        `v1/tenant/post_deregistration_restoredata_apply`,
        data,  // 发送普通对象，axios会自动转为JSON
        {
            headers: {
                'X-Auth-Token': TOKEN_CONFIG.AICS_TOKEN 
                // 不要手动设置Content-Type，让axios自动处理
            }
        }
    )
    return response
}

export async function load_tenant_deregistration_restoredata_info(apply_id) {
    try {
        const response = await ssoHttp.get(
            `/v1/tenant/deregistration_restoredata?apply_id=${apply_id}`,  {
                headers: { 
                    'X-Auth-Token': TOKEN_CONFIG.AICS_TOKEN              
                }      
            })    
            console.log("/tenant/load_tenant_deregistration_restoredata_info",response);
  // 统一处理响应格式
  if (response == null || response.status !== 200) {
    throw new Error(response?.data?.message || '获取租户注销后恢复数据请求信息失败');
  }
  return response.data;
} catch (error) {
    return error
 }
}